// import axios from '../helpers/axios'

// Sotore de visor de contenido de clicken1
export default{
    // para sirve para acceder  mapstate de la siguiente forma para los modulos ...(mapState 'progDocente', ['setActivarCalendario', 'setCloseCalendario'])
    namespaced :true,

    state : {
        
        modalVisor : false,
        periodo: null,
        id_clase: null,
        clases: null,
        api_list_contenidos: null



    },
    // cambia los estados de las variables principales
    // de las variables princiaples


    mutations : {
        setCloseVisor(state){
            state.modalVisor = false
        },

        setActivarVisor(state, datos){
            state.modalVisor = true,
            state.periodo = ( (datos.periodo == null) || (datos.periodo == "") ) ? null : datos.periodo
            state.id_clase = ( (datos.id_clase == null) || (datos.id_clase == "") ) ? null : datos.id_clase
        },

        setData(state, datos){
            state.clases = datos.clases
            state.api_list_contenidos = datos.clases
        },
    },
    /*
    //declarar actions
    actions  : {
        async getContenido(state, context){
            try{
                
                let response = await axios.get("/manager/contenido/list/"+id+"");
                //let response = await   axios.get("/manager/gradoCkOne/")
                //this.api_list_contenidos = response.data;
                context.commit('setData', {
                    clases: response.data
                })
            }
            catch(error){
                console.log(error);
            }
        }
    },

    */


    getters:{
        getConfiguracion:(state) => {
            return { 
                               
                "modalVisor":state.modalVisor,
                "id_clase"  :state.id_clase,
                "periodo"   :state.periodo,
                "clases"    :state.clases
                
            }
        },
    },
}




/*
    /////////////////////
    ////  Aplicando   ///
    ////////////////////
    import {mapMutations} from 'vuex'

    data: () => ({}],

    methods: {
        ...mapMutations('progDocente', ['setActivarCalendario', 'setCloseCalendario']),

        this.setActivarCalendario({periodo:"", id_docente:""})

        // this.setCloseCalendario()

    },
*/